import { useState } from 'react';
import './IPProtection.css';

const ACCESS_CODE = "000000";

const BYPASS_PATHS = [
  '/payment/success',
  '/payment/cancel',
  '/subscription/success',
  '/subscription/cancel'
];

export const isEmergentDomain = window.location.hostname.includes('.emergent.host') || 
                                window.location.hostname.includes('.preview.emergentagent.com') ||
                                window.location.hostname.includes('.deploy.emergentcf.cloud') ||
                                window.location.hostname.includes('.emergentcf.cloud');

export const isPreviewDomain = isEmergentDomain;

export const shouldBypassProtection = () => {
  const currentPath = window.location.pathname;
  if (BYPASS_PATHS.some(path => currentPath.startsWith(path))) return true;
  if (localStorage.getItem('token')) return true;
  return false;
};

export const checkAccessGranted = () => {
  if (shouldBypassProtection()) return true;
  return localStorage.getItem("access_granted") === "true";
};

const IPProtection = ({ onAccessGranted }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [isShaking, setIsShaking] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code === ACCESS_CODE) {
      setSuccess(true);
      localStorage.setItem("access_granted", "true");
      setTimeout(() => onAccessGranted(), 800);
    } else {
      setError("الرمز غير صحيح");
      setIsShaking(true);
      setTimeout(() => setIsShaking(false), 500);
    }
  };

  return (
    <div className="launch-container">

      <div className={`launch-card ${isShaking ? 'shake' : ''} ${success ? 'success-glow' : ''}`}>
        {/* Logo with pulse */}
        <div className="logo-wrapper">
          <div className="logo-ring"></div>
          <img src="/lwt-logo-new.png" alt="Learn With Trust" className="launch-logo" style={{ filter: 'invert(1) brightness(2)' }} />
        </div>

        {/* Brand Name */}
        <h1 className="brand-name">
          <span className="brand-learn">Learn</span>
          <span className="brand-with">With</span>
          <span className="brand-trust">Trust</span>
        </h1>

        {/* Coming Soon */}
        <div className="coming-soon-badge">
          <span className="pulse-dot"></span>
          ترقبوا الانطلاق
        </div>

        <p className="launch-subtitle">
          منصة تعليمية متطورة تربط الطلاب بالأساتذة المستقلين
        </p>

        {/* Divider */}
        <div className="launch-divider">
          <div className="divider-line"></div>
          <span className="divider-text">تجريب المنصة</span>
          <div className="divider-line"></div>
        </div>

        <p className="access-hint">
          إذا كان لديك رمز الدخول، يمكنك تجربة المنصة الآن
        </p>

        {/* Code Input */}
        <form onSubmit={handleSubmit} className="code-form">
          <div className="code-input-wrapper">
            <input
              type="password"
              value={code}
              onChange={(e) => { setCode(e.target.value); setError(""); }}
              placeholder="أدخل الرمز"
              className={`code-input ${error ? 'input-error' : ''} ${success ? 'input-success' : ''}`}
              data-testid="ip-protection-code-input"
              dir="ltr"
              maxLength={10}
            />
          </div>
          {error && <p className="error-msg" data-testid="ip-protection-error">{error}</p>}
          <button type="submit" className={`enter-btn ${success ? 'btn-success' : ''}`} data-testid="ip-protection-submit-btn">
            {success ? '✓' : 'دخول'}
          </button>
        </form>

        {/* Footer */}
        <div className="launch-footer">
          <img src="/lwt-icon-new.png" alt="" className="footer-logo" style={{ filter: 'invert(1)' }} />
          <p className="company-line">Trust Ed Techno for Development and Innovation L.L.C.</p>
          <p className="company-line-ar">ترست اي دي تكنو للتطوير والابتكار ذ.م.م</p>
          <p className="copyright">© 2026</p>
        </div>
      </div>
    </div>
  );
};

export default IPProtection;
